export { CovidIcon } from "./covid";
